// You can write your custom Javascript here
const $ = jQuery;
const $body = $("body");

$(function() {
    //popupInit();
    reservationBtn();
});


function reservationBtn() {
  const $resyCnt = $("#resy-embed");

  $(document).on("click", '[href*="resy.com"]', triggerResy);
  
  function triggerResy(e) {
    e.preventDefault();
    $resyCnt.find("span").trigger("click");//console.log("trigger resy click");
  }
}
function popupInit() {
  const $popup = $("#site-popup");
  if (!$popup.length) return;
  const popupViewed = getCookie("popup_viewed");
  if (popupViewed != "true") {
    $body.append($popup);
    $popup.on("click", closePopup);
    setTimeout(openPopup, 50);
  }
  else { console.log("popup already viewed"); }
  
  function openPopup() {
    $body.addClass("popup-active");
    $popup.addClass("active");
  }
  function closePopup(e) {//console.log("e",e);
    if ($(e.target).is("a")) return;
    e.preventDefault();
    $body.removeClass("popup-active");
    $popup.removeClass("active");
    setCookie("popup_viewed", "true", 21);//21 is the number of days. Change as needed
  }
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}